import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MetaDataService } from './services/store/meta-data.service';
import { SsoAuthService } from './sso/Services/sso-auth.service';
import { IdleTimerService } from './sso/Services/idle-timer.service';
import { ssoConfig } from './sso/config/sso.config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'SATSANG_USA_PHIL_ONLINE_UI';

  private blockShortcuts = (e: KeyboardEvent) => {
    if (e.ctrlKey || e.altKey || e.metaKey || /^F\d{1,2}$/.test(e.key)) {
      const isV = e.key.toLowerCase() === 'v';
      const isC = e.key.toLowerCase() === 'c';
      const isA = e.key.toLowerCase() === 'a';
      const isZ = e.key.toLowerCase() === 'z';

      if ((e.ctrlKey || e.metaKey) && (isV || isC || isZ || isA)) {
        // allow paste option
      } else e.preventDefault();
    }
  };

  constructor(
    private metaDataService: MetaDataService,
    private ssoauth: SsoAuthService,
    private idleTimerService: IdleTimerService,
  ) { }

  ngOnInit() {
    window.addEventListener('keydown', this.blockShortcuts, true);
    window.addEventListener('keyup', this.blockShortcuts, true);



    const token = localStorage.getItem('AccessToken');
    if (token) {
      this.ssoauth.initTimer();
      this.idleTimerService.startWatching(() => {
        console.log('Logging out due to inactivity...');
        this.ssoauth.logOut(false);
      });
    }

    this.ssoauth.tokenExpiresInSecond.subscribe((value: number) => {
      // console.log('COUNT DOWN: ', value);
      if (value) {
        if (value <= 0) {
          this.ssoauth.logOut(false);
        }
        if (value && value <= ssoConfig.sso.timeBeforeCallingRefreshInSecs && !this.ssoauth.isRefreskTokenApiCalled) {
          console.log('REFRESH MEE');
          this.ssoauth.renewAccessToken();
        }
      }
    });
  }

  ngOnDestroy() {
    window.removeEventListener('keydown', this.blockShortcuts, true);
    window.removeEventListener('keyup', this.blockShortcuts, true);
  }
}
